import Component from '@ux/component';
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import Link from '@ux/link';
import { getCurrentHref } from './util';
import { golf, breakpoints } from './enums';

class ContactUs extends Component {
  constructor(props) {
    super(...arguments);

    this.imageId = Math.floor(Math.random() * (5 - 1)) + 1;
    this.currentHref = getCurrentHref(
      props.currentHref,
      this.isBrowser,
      this.getDocumentLocation()
    );
  }

  componentDidMount() {
    this.breakpoint(...breakpoints);
  }

  componentWillUnmount() {
    this.breakup();
  }

  getDocumentLocation() {
    if (typeof window !== 'undefined') {
      return document && document.location && document.location.href;
    }
    return null;
  }

  render() {
    const { intl, urls, app } = this.props;
    const isNotDesktop =
      ['mobile', 'phablet', 'tablet'].indexOf(this.state.breakpoint) !== -1;

    let contactUsUrl =
      urls && urls.helpCenterContactUs && urls.helpCenterContactUs.href;
    if (app === 'community') {
      contactUsUrl = urls && urls.contactUs && urls.contactUs.href;
    }
    const isActive = contactUsUrl === this.currentHref;

    const contactImage = `//img1.wsimg.com/dc-assets/help-header/v1/img/contact${this.imageId}.jpg`;
    const highlightClassNames = this.classNames('help-contact-us-highlight', { active: isActive });

    return (
      <div className='help-contact-us'>
        <Link className='help-contact-us-link' href={ contactUsUrl }>
          <div className='help-contact-us-image'>
            <img
              src={ contactImage }
              alt={ intl.formatMessage({
                id: isNotDesktop ? golf.contactUs : golf.contactUs247
              }) }
            />
          </div>
          <div className='help-contact-us-link-container'>
            <FormattedMessage
              id={ isNotDesktop ? golf.contactUs : golf.contactUs247 }
            />
            <div className={ highlightClassNames } role='presentation'>
              {' '}
            </div>
          </div>
        </Link>
      </div>
    );
  }
}

ContactUs.propTypes = {
  urls: PropTypes.object.isRequired,
  currentHref: PropTypes.string,
  app: PropTypes.string,
  intl: PropTypes.object
};

export default injectIntl(ContactUs);
